import { computed, makeObservable } from "mobx";
import type { ICurrentWindowStore } from "../ICurrentWindowStore";

export interface ICurrentDocumentStore {
    currentDocument: Document;

    addEventListener<K extends keyof DocumentEventMap>(type: K, listener: (this: Document, ev: DocumentEventMap[K]) => any, options?: boolean | AddEventListenerOptions): void;

    addEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions): void;

    removeEventListener<K extends keyof DocumentEventMap>(type: K, listener: (this: Document, ev: DocumentEventMap[K]) => any, options?: boolean | EventListenerOptions): void;

    removeEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | EventListenerOptions): void;
}

export class CurrentDocumentStore implements ICurrentDocumentStore {
    constructor(private readonly currentWindowStore: ICurrentWindowStore) {
        makeObservable(this);
    }

    @computed
    public get currentDocument(): Document {
        const { currentWindow } = this.currentWindowStore;
        return currentWindow.document;
    }

    addEventListener<K extends keyof DocumentEventMap>(type: K, listener: (this: Document, ev: DocumentEventMap[K]) => any, options?: boolean | AddEventListenerOptions): void;
    addEventListener(type: string, listener: EventListener | EventListenerObject, options?: boolean | AddEventListenerOptions): void;
    addEventListener(type: any, listener: (this: Document, ev: any) => any, options?: boolean | AddEventListenerOptions): void {
        this.currentDocument.addEventListener(type, listener, options);
    }

    removeEventListener<K extends keyof DocumentEventMap>(type: K, listener: (this: Document, ev: DocumentEventMap[K]) => any, options?: boolean | EventListenerOptions): void;
    removeEventListener(type: string, listener: EventListener | EventListenerObject, options?: boolean | EventListenerOptions): void;
    removeEventListener(type: any, listener: (this: Document, ev: any) => any, options?: boolean | EventListenerOptions): void {
        this.currentDocument.removeEventListener(type, listener, options);
    }
}
